export default "__VITE_ASSET__C$$cKeQF__"